import setupIsotope from '../util/setupIsotope';
import setupInsightSwiper from '../util/setupInsightSwiper';
import 'isotope-layout/dist/isotope.pkgd.min.js';
import Swiper from 'swiper';

const home = function () {
  console.log('hello from home');

  setTimeout(function () {
    setupIsotope();
    setupInsightSwiper();
    setupSiedlungenSwiper();
  }, 500);

  function setupSiedlungenSwiper() {
    if ($('.swiper-container').length) {
      // Swiper for siedlungen
      let siedlungSwiper = new Swiper('.swiper-container.siedlungen', {
        speed: 400,
        spaceBetween: 15,
        slidesPerView: 2,
        loop: true,
        init: true,
        watchSlidesVisibility: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        lazy: {
          loadPrevNext: true,
        },
        breakpoints: {
          576: {
            slidesPerView: 1,
          },
        },
      });

      siedlungSwiper.update();
    }
  }
};

export default home;



// WEBPACK FOOTER //
// ./scripts/barba-views/home.js